module.exports = __webpack_public_path__ + "static/media/MY.b977463a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MY.svg
// module id = 2220
// module chunks = 7